export const setNotifications = (state, payload) => {
    state.notifications = payload;
    state.notificationCount = payload.length;
};
